import { scheduleDateAtom } from '@/atoms/sessionAtoms';
import { openedSessionTabAtom, openedSessionTabEnum } from '@/atoms/sideNavAtoms';
import { DEFAULT_DATE_FORMAT } from '@/components/constants';
import { useRetrieveAppointmentOrSchedule } from '@/components/layout/Navigation/sessions/side-nav-list/integration/hooks/useRetrieveAppointmentOrSchedule';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { convertMomentToDateFnsFormat } from '@/lib/parseTimeStamp';
import { TypographyCaption, TypographyFootNote } from '@heidi/design-system/typography';
import { format } from 'date-fns';
import { useAtomValue } from 'jotai';

function SessionBarStatusText() {
  const openedSessionTab = useAtomValue(openedSessionTabAtom);
  const scheduleDate = useAtomValue(scheduleDateAtom);
  const { isPending: isApptOrSchedulePending, searchResult: ehrSearchResult } =
    useRetrieveAppointmentOrSchedule();
  const isMobile = useIsMobile();
  const { data: user_settings_date_format } = useQueryUser(
    (data) => data?.session_settings?.date_format
  );
  const dateFormat = convertMomentToDateFnsFormat(
    user_settings_date_format || DEFAULT_DATE_FORMAT
  );

  const resultsCount = ehrSearchResult?.length ?? 0;

  const statusText = isApptOrSchedulePending
    ? 'Syncing appointments...'
    : scheduleDate
      ? `${resultsCount} result${resultsCount > 1 ? 's' : ''} on
            ${scheduleDate && format(scheduleDate, `${dateFormat} h:mma`)}`
      : 'Please select a date';

  if (!(openedSessionTab === openedSessionTabEnum.UPCOMING && scheduleDate)) {
    return <></>;
  }

  if (isMobile) {
    return (
      <TypographyCaption className="w-full text-center text-text-secondary">
        {statusText}
      </TypographyCaption>
    );
  } else {
    return (
      <TypographyFootNote className="w-full text-center text-text-secondary">
        {statusText}
      </TypographyFootNote>
    );
  }
}

SessionBarStatusText.displayName = 'SessionBarStatusText';
export default SessionBarStatusText;
